module.exports = __webpack_public_path__ + "static/img/tabela.6c17e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/energy-drink/tabela.png
// module id = BoHC
// module chunks = 0